import { useEffect, useState } from "react";
import { CloudOff, RefreshCw, TriangleAlert, X } from "lucide-react";
import { useOfflineState } from "@/lib/offline/state";
import { dropConflict, flush, takeNotices, clearNotice } from "@/lib/offline/sync";
import { fmtDateTime } from "@/lib/time";

const Conflict = ({ c }) => (
  <li data-testid={`sync-conflict-${c.seq}`} className="rounded-md border border-red-500/60 bg-red-950/40 p-3 text-sm">
    <p className="font-semibold text-red-100">{c.label} non synchronisé · {fmtDateTime(c.device_at)}</p>
    <p className="mt-1 text-red-200">{c.detail}</p>
    <button type="button" data-testid={`sync-conflict-drop-${c.seq}`}
      onClick={() => window.confirm("Retirer cette opération de la file ? Les saisies locales concernées ne seront pas envoyées.") && dropConflict(c.seq)}
      className="mt-2 text-xs font-semibold text-red-200 underline">Retirer de la file d'envoi</button>
  </li>
);

export const OfflineBanner = () => {
  const s = useOfflineState();
  const [notices, setNotices] = useState([]);
  useEffect(() => { takeNotices().then(setNotices); }, [s.pending]);
  if (s.online && !s.pending && !notices.length) return null;
  return (
    <div data-testid="offline-banner" className="mb-4 space-y-2">
      {(!s.online || s.pending > 0) && (
        <div className={`flex flex-wrap items-center gap-3 rounded-lg border p-3 text-sm ${s.online ? "border-sky-500/50 bg-sky-950/40 text-sky-100" : "border-amber-500/60 bg-amber-950/50 text-amber-100"}`}>
          {s.online ? <RefreshCw className="h-4 w-4" /> : <CloudOff className="h-4 w-4" />}
          <span data-testid="offline-status" className="flex-1">
            {s.online ? "En ligne" : "Hors ligne : vos saisies sont enregistrées sur cet appareil"}
            {s.pending > 0 && <> · <b data-testid="offline-pending-count">{s.pending}</b> élément(s) en attente d'envoi</>}
            {s.lastSync && <> · dernière synchro {fmtDateTime(new Date(s.lastSync).toISOString())}</>}
          </span>
          {s.online && s.pending > 0 && <button type="button" data-testid="offline-sync-now" onClick={() => flush()} className="font-semibold underline">Synchroniser</button>}
        </div>
      )}
      {s.conflicts.length > 0 && <ul data-testid="sync-conflicts" className="space-y-2">{s.conflicts.map((c) => <Conflict key={c.seq} c={c} />)}</ul>}
      {notices.map((n) => (
        <div key={n.id} data-testid={`sync-notice-${n.id}`} className="flex items-start gap-2 rounded-md border border-amber-500/60 bg-amber-950/40 p-3 text-sm text-amber-100">
          <TriangleAlert className="mt-0.5 h-4 w-4 shrink-0" /><span className="flex-1">{n.text}</span>
          <button type="button" aria-label="Fermer" data-testid={`sync-notice-close-${n.id}`} onClick={() => clearNotice(n.id).then(() => takeNotices().then(setNotices))}><X className="h-4 w-4" /></button>
        </div>
      ))}
    </div>
  );
};
